import * as React from 'react';
import {Link as RouterLink} from 'react-router-dom';

import classnames from 'classnames';

import {Link} from 'shells/link/link';

import {PageTitleBar} from '../../../layout';

import {EmailSyncingSettings} from './email-syncing-settings';
import {GetEmailSyncSettings} from './get-email-sync-settings';

import styles from './email-syncing-page.module.css';

export function EmailSyncingPage() {
    const refetchRef = React.useRef<(() => Promise<any>) | null>(null);

    React.useEffect(() => {
        const refetchEmailSyncSettings = () => {
            if (refetchRef.current) {
                refetchRef.current();
            }
        };

        window.addEventListener('email-connected', refetchEmailSyncSettings);

        return () => {
            window.removeEventListener('email-connected', refetchEmailSyncSettings);
        };
    }, []);

    return (
        <React.Fragment>
            <PageTitleBar
                title='Email sync settings'
                subheaderPrimaryText='Sync your email into Nutshell'
                buttons={
                    // @ts-expect-error
                    <Link as={RouterLink} variant='button-secondary' size='big' to='/email/inbox'>
                        Inbox
                    </Link>
                }
            />
            <div className={classnames('pad-16', styles['settings-container'])}>
                <GetEmailSyncSettings>
                    {(emailSyncingSettings) => {
                        refetchRef.current = emailSyncingSettings.refetch;

                        return <EmailSyncingSettings {...emailSyncingSettings} />;
                    }}
                </GetEmailSyncSettings>
            </div>
        </React.Fragment>
    );
}
